export const typeOfAnnualOptions = [
    { TypeId: 1, TypeName: "Annual" },
    { TypeId: 2, TypeName: "Multi-Annual" }
];

export const typeOfIPAOptions = [
    { TypeId: 1, TypeName: "IPA I" },
    { TypeId: 2, TypeName: "IPA II" },
    { TypeId: 3, TypeName: "IPA III" }
];

export const typeOfFAYearOptions = [
    //{ TypeId: 2000, TypeName: "2000" },
    //{ TypeId: 2001, TypeName: "2001" },
    //{ TypeId: 2002, TypeName: "2002" },
    //{ TypeId: 2003, TypeName: "2003" },
    //{ TypeId: 2004, TypeName: "2004" },
    //{ TypeId: 2005, TypeName: "2005" },
    //{ TypeId: 2006, TypeName: "2006" },
    { TypeId: 2007, TypeName: "2007", IPATypeId: 1 },
    { TypeId: 2008, TypeName: "2008", IPATypeId: 1 },
    { TypeId: 2009, TypeName: "2009", IPATypeId: 1 },
    { TypeId: 2010, TypeName: "2010", IPATypeId: 1 },
    { TypeId: 2011, TypeName: "2011", IPATypeId: 1 },
    { TypeId: 2012, TypeName: "2012", IPATypeId: 1 },
    { TypeId: 2013, TypeName: "2013", IPATypeId: 1 },
    { TypeId: 2014, TypeName: "2014", IPATypeId: 2 },
    { TypeId: 2015, TypeName: "2015", IPATypeId: 2 },
    { TypeId: 2016, TypeName: "2016", IPATypeId: 2 },
    { TypeId: 2017, TypeName: "2017", IPATypeId: 2 },
    { TypeId: 2018, TypeName: "2018", IPATypeId: 2 },
    { TypeId: 2019, TypeName: "2019", IPATypeId: 2 },
    { TypeId: 2020, TypeName: "2020", IPATypeId: 2 },
    { TypeId: 2021, TypeName: "2021", IPATypeId: 3 },
    { TypeId: 2022, TypeName: "2022", IPATypeId: 3 },
    { TypeId: 2023, TypeName: "2023", IPATypeId: 3 },
    { TypeId: 2024, TypeName: "2024", IPATypeId: 3 },
    { TypeId: 2025, TypeName: "2025", IPATypeId: 3 },
    { TypeId: 2026, TypeName: "2026", IPATypeId: 3 },
    { TypeId: 2027, TypeName: "2027", IPATypeId: 3 },
    { TypeId: 2028, TypeName: "2028" },
    { TypeId: 2029, TypeName: "2029" },
    { TypeId: 2030, TypeName: "2030" },
    //{ TypeId: 2031, TypeName: "2031" },
    //{ TypeId: 2032, TypeName: "2032" },
    //{ TypeId: 2033, TypeName: "2033" },
    //{ TypeId: 2034, TypeName: "2034" },
    //{ TypeId: 2035, TypeName: "2035" },
    //{ TypeId: 2036, TypeName: "2036" },
    //{ TypeId: 2037, TypeName: "2037" },
    //{ TypeId: 2038, TypeName: "2038" },
    //{ TypeId: 2039, TypeName: "2039" },
    //{ TypeId: 2040, TypeName: "2040" },
    //{ TypeId: 2041, TypeName: "2041" },
    //{ TypeId: 2042, TypeName: "2042" },
    //{ TypeId: 2043, TypeName: "2043" },
    //{ TypeId: 2044, TypeName: "2044" },
    //{ TypeId: 2045, TypeName: "2045" },
    //{ TypeId: 2046, TypeName: "2046" },
    //{ TypeId: 2047, TypeName: "2047" },
    //{ TypeId: 2048, TypeName: "2048" },
    //{ TypeId: 2049, TypeName: "2049" },
    //{ TypeId: 2050, TypeName: "2050" }
];

export const typeOfFAMAOptions = [
    { TypeId: 1, TypeName: "Multi-Annual 2007" },
    { TypeId: 2, TypeName: "Multi-Annual 2008" },
    { TypeId: 3, TypeName: "Multi-Annual 2009" },
    { TypeId: 4, TypeName: "Multi-Annual 2010" },
    { TypeId: 5, TypeName: "Multi-Annual 2011" },
    { TypeId: 6, TypeName: "Multi-Annual 2012" },
    { TypeId: 7, TypeName: "Multi-Annual 2013" },
    { TypeId: 8, TypeName: "Multi-Annual 2014" },
    { TypeId: 9, TypeName: "Multi-Annual 2015" },
    { TypeId: 10, TypeName: "Multi-Annual 2016" },
    { TypeId: 11, TypeName: "Multi-Annual 2017" },
    { TypeId: 12, TypeName: "Multi-Annual 2018" },
    { TypeId: 13, TypeName: "Multi-Annual 2019" },
    { TypeId: 14, TypeName: "Multi-Annual 2020" },
    { TypeId: 15, TypeName: "Multi-Annual 2021" },
    { TypeId: 16, TypeName: "Multi-Annual 2022" },
    { TypeId: 17, TypeName: "Multi-Annual 2023" },
    { TypeId: 18, TypeName: "Multi-Annual 2024" },
    { TypeId: 19, TypeName: "Multi-Annual 2025" },
    { TypeId: 20, TypeName: "Multi-Annual 2026" },
    { TypeId: 21, TypeName: "Multi-Annual 2027" },
    { TypeId: 22, TypeName: "Multi-Annual 2028" },
    { TypeId: 23, TypeName: "Multi-Annual 2029" },
    { TypeId: 24, TypeName: "Multi-Annual 2030" },
];

export const sectorOptions = [
    { TypeId: 1, TypeName: "Civil Society" },
    { TypeId: 2, TypeName: "Judiciary" },
    { TypeId: 3, TypeName: "Fundamental Rights" },
    { TypeId: 4, TypeName: "Home Affairs" },
    { TypeId: 5, TypeName: "Environment and Climate Action" },
    { TypeId: 6, TypeName: "Transport" },
    { TypeId: 7, TypeName: "Energy" },
    { TypeId: 8, TypeName: "Competitiveness and Innovation" },
    { TypeId: 9, TypeName: "Education, Employment and Social Policies" },
    { TypeId: 10, TypeName: "Agriculture and Rural Development – Institution and Capacity Building" },
    { TypeId: 11, TypeName: "RRAA-Standalone Projects" },
];

export const typeOfProjectOptions = [
    //{ TypeId: 1, TypeName: "Direct Grant" },
    { TypeId: 2, TypeName: "Grant" },
    { TypeId: 3, TypeName: "Service" },
    { TypeId: 4, TypeName: "Twinning" },
    { TypeId: 5, TypeName: "Supply" },
    { TypeId: 6, TypeName: "Works" },
    { TypeId: 7, TypeName: "Other" },
];

export const interviewPersonCategories = [
    { TypeId: 1, TypeName: "Beneficiary" },
    { TypeId: 2, TypeName: "Partner Country" },
    { TypeId: 3, TypeName: "Stakeholder" },
    { TypeId: 4, TypeName: "Other" },
    { TypeId: 5, TypeName: "DEUA" },
    { TypeId: 6, TypeName: "EU Delegation" },
    { TypeId: 7, TypeName: "Contracting Authority" },
    { TypeId: 8, TypeName: "End Beneficiary" },
    { TypeId: 9, TypeName: "Lead Institution" },
    { TypeId: 10, TypeName: "Contractor" },
    { TypeId: 11, TypeName: "Final Beneficiary" },
];

export function returnTypeIdNameArrayElement(array, element) {
    for (var i = 0; i < array.length; i++) {
        if (array[i].TypeId == element) {
            return array[i];
        }
    }

    return ({ TypeId: "", TypeName: "" });
};

export const greenValue = 5;
export const orangeValue = 3;
export const redValue = 1;




// WEBPACK FOOTER //
// ./src/components/Enums.js